import axios from 'axios';
import {
  errorResponse,
  validateApiData
} from '../../utils/validators/validators';

import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants';
import { SERVER_URL } from '../../utils/config/constants';
import { getCookies } from '../../utils/getToken';
import { NotificationManager } from 'react-notifications';

export const bookingList = async params => {
  var authToken = getCookies();
  try {
    const { data } = await axios({
      method: 'get',
      url: `${SERVER_URL}/booking/my`,
      params: params,
      headers: { 'x-auth-token': authToken }
    });
    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    return errorResponse;
  }
};

export const getRecurringBookings = async params => {
  var authToken = getCookies();
  try {
    const { data } = await axios({
      method: "get",
      url: `${SERVER_URL}/booking/fetch-recurring`,
      headers: { "x-auth-token": authToken }
    });

    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    console.log("Error in booking all", e);
    return errorResponse;
  }
};



export const providerBookingList = async params => {
  var authToken = getCookies();
  try {
    let hitUrl = '';
    if (params.requested) {
      hitUrl = SERVER_URL + "/booking/list-requests"
    } else {
      hitUrl = SERVER_URL + "/provider/bookings"
    }

    const { data } = await axios({
      method: 'get',
      url: hitUrl,
      params: params,
      headers: { 'x-auth-token': authToken }
    });
    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    return errorResponse;
  }
};


export const mousamproviderTodayBookingList = async params => {
  // alert("@")
  console.log("33333333333333333333333333333")

  var authToken = getCookies();
  try {
    const { data } = await axios({
      method: "get",
      params: params,
      url: `${SERVER_URL}/booking/today-requests`,
      headers: { "x-auth-token": authToken }
    });
    console.log("4444444444444444444444444444444", data)

    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    console.log("Error in booking all", e);
    return errorResponse;
  }
};

export const mousamproviderTodayOtherBookingList = async params => {
  console.log(params)
  // alert("mp "+params)
  console.log("33333333333333333333333333333")

  var authToken = getCookies();
  try {
    const { data } = await axios({
      method: "get",
      params: { "type": params },
      url: `${SERVER_URL}/provider/today-all-booking`,
      headers: { "x-auth-token": authToken }
    });
    console.log("4444444444444444444444444444444", data)

    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    console.log("Error in booking all", e);
    return errorResponse;
  }
};

export const mousamproviderAllBookingList = async params => {
  console.log("33333333333333333333333333333")

  var authToken = getCookies();
  try {
    const { data } = await axios({
      method: "get",
      params: params,
      url: `${SERVER_URL}/booking/list-requests`,
      headers: { "x-auth-token": authToken }
    });
    console.log("4444444444444444444444444444444", data)

    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    console.log("Error in booking all", e);
    return errorResponse;
  }
};

export const bookingDetail = async params => {
  console.log("params::::::::", params)
  var authToken = getCookies();
  try {
    const { data } = await axios({
      method: 'get',
      url: `${SERVER_URL}/booking/detail?bookingId=${params.bookingId}`,
      params: params,
      headers: { 'x-auth-token': authToken }
    });
    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    return errorResponse;
  }
};

export const bookingTimeSlot = async params => {
  var authToken = getCookies();
  console.log("mms", params)
  try {
    const { data } = await axios({
      method: 'post',
      url: `${SERVER_URL}/provider/checkslots`,
      data: params,
      headers: { 'x-auth-token': authToken }
    });
    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    return errorResponse;
  }
};

export const promoCodeList = async () => {
  var authToken = getCookies();
  try {
    const { data } = await axios({
      method: 'get',
      url: `${SERVER_URL}/promocodes/fetch`,
      // data: params,
      headers: { 'x-auth-token': authToken }
    });
    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    return errorResponse;
  }
};

export const checkPromoCode = async params => {
  var authToken = getCookies();
  try {
    const { data } = await axios({
      method: 'post',
      url: `${SERVER_URL}/promocodes/check`,
      data: params,
      headers: { 'x-auth-token': authToken }
    });
    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    return errorResponse;
  }
};

export const cardList = async () => {
  var authToken = getCookies();
  try {
    let { data } = await axios({
      method: 'get',
      url: `${SERVER_URL}/cards/list`,

      headers: { 'x-auth-token': authToken }
    });
    return validateApiData(data) ? data : errorResponse;
  } catch (e) {
    return errorResponse;
  }
};



// WEBPACK FOOTER //
// ./src/apiHelpers/booking/list.js